<nb-card *ngIf="!userId; else userFee">
  <nb-card-header>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <i class="fal fa-chart-line ms-1"></i>
        کارمزد ها به تفکیک روز
      </div>
      <button nbButton (click)="exportExcel()" status="primary">خروجی اکسل بازه انتخابی</button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div>
      <h6 class="mb-3">مجموع کارمزد بازده انتخابی : {{ total | number }}</h6>
      <app-range-picker (submit)="getFeeHistory($event)" [loading]="loading"></app-range-picker>
      <canvas
        *ngIf="chartData.datasets.length > 0"
        baseChart
        width="225"
        height="106"
        [data]="chartData"
        [type]="'bar'"
        [labels]="chartLabel"
        [options]="chartOptions"
      ></canvas>
    </div>
    <div *ngIf="loading" class="loading-backdrop">
      <i class="fal fa-circle-notch fa-spin fa-3x"></i>
    </div>
  </nb-card-body>
</nb-card>
<ng-template #userFee>
  <div>
    <app-range-picker
      (submit)="getFeeHistory($event)"
      [errors]="errors"
      [loading]="loading"
    ></app-range-picker>
    <canvas
      *ngIf="chartData.datasets.length > 0"
      baseChart
      width="225"
      height="106"
      [data]="chartData"
      [type]="'bar'"
      [labels]="chartLabel"
      [options]="chartOptions"
    ></canvas>
  </div>
  <div *ngIf="loading" class="loading-backdrop">
    <i class="fal fa-circle-notch fa-spin fa-3x"></i>
  </div>
</ng-template>
